<template>
  <common-dialog ref="dialog" width="740px" title="修改商品规格" id-key="id" :data="data" :form-rules="rules"
    :save-func="saveDataFunc" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-alert type="warning" :closable="false"
        description="修改后的商品信息仅会出现在快递单上，不会替代订单列表的商品信息">
      </el-alert>
      <div style="height: 5px;"></div>
      <el-form-item label="当前商品信息" label-width="140px">
        <span>{{ data.goodsName }}</span>
      </el-form-item>
      <el-form-item label="修改后商品打印信息" prop="editGoodsName" label-width="140px">
        <el-input type="textarea" v-model="data.editGoodsName"
          placeholder="请输入要在快递单上打印的商品信息，最多输入30个汉字（60个字符）"></el-input>
      </el-form-item>
      <el-form-item label="当前规格信息" label-width="140px">
        <span>{{ data.goodsSpec }}</span>
      </el-form-item>
      <el-form-item label="修改后商品打印信息" prop="editGoodsSpec" label-width="140px">
        <el-input v-model="data.editGoodsSpec" placeholder="请输入要在快递单上打印的规格信息，最多输入30个汉字（60个字符）"></el-input>
      </el-form-item>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="save">保 存</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require('@/api/wx/order').default,
      data: {
        id: 0,
        goodsName: "",
        editGoodsName: "",
        goodsSpec: "",
        editGoodsSpec: ""
      },
      rules: {
        // editGoodsName: [{ required: true, message: '请输入' }], 
        // editGoodsSpec: [{ required: true, message: '请输入' }], 
      },
    };
  },
  mounted() { },
  methods: {
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: null })
        // this.api.postSender(this.data).then(res => {
        //   if (res) {
        //     resolve({ Code: 1, Msg: res.errorMessage })
        //   } else {
        //     resolve({ Code: 0, Msg: null })
        //   }
        // })
      })
    },
  },
};
</script>
